import { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Checkbox,
  List,
  Card,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { English } from "../../../constant/EnglishFallback";
import { useSelector } from "react-redux";

function ProductsCard({ products, handleToggle }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.ResumeBuilder || {};
  const {
    TEXT_USER_PRODUCT_INFO = English.ResumeBuilder.TEXT_USER_PRODUCT_INFO,
    TEXT_NO_PRODUCT_TO_PROFILE = English.ResumeBuilder.TEXT_NO_PRODUCT_TO_PROFILE
  } = LanguageData || {};

  const getProductDescriptionText = (item) => {
    if (item.productType && item.manufacturerName) {
      return `${item.productType} | ${item.manufacturerName}`;
    } else if (item.productType) {
      return `${item.productType} `;
    } else if (item.manufacturerName) {
      return `${item.manufacturerName} `;
    } else {
      return "Unknown";
    }
  };

  return (
    <Card className="pagelist-content" sx={{ p: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">{TEXT_USER_PRODUCT_INFO}</Typography>
        <IconButton color="primary" onClick={() => setIsExpanded((prev) => !prev)}>
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      {isExpanded && (
        <List disablePadding>
          {products.length > 0 ? (
            <Stack spacing={1} pt={1}>
              {products.map((product, index) => {
                return (
                  <Card
                    key={index.toString()}
                    className="pagelist-content"
                    sx={{ marginTop: "0px", padding: 0, cursor: "pointer" }}>
                    <ListItem
                      key={index.toString()}
                      alignItems="flex-start"
                      sx={{ m: 0, p: 0 }}
                      secondaryAction={
                        <Checkbox
                          edge="end"
                          onChange={() => handleToggle(product.id, "ProductsCard")}
                          checked={product.isSelected}
                        />
                      }>
                      <ListItemButton
                        onClick={() => handleToggle(product.id, "ProductsCard")}
                        alignItems="flex-start"
                        sx={{ m: 0 }}>
                        <ListItemText
                          primary={
                            <Typography variant="body1"> {product?.productName} </Typography>
                          }
                          secondary={
                            <Typography variant="body2" color="textSecondary">
                              {getProductDescriptionText(product)}
                            </Typography>
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                  </Card>
                );
              })}
            </Stack>
          ) : (
            <Typography>{TEXT_NO_PRODUCT_TO_PROFILE}</Typography>
          )}
        </List>
      )}
    </Card>
  );
}

export default ProductsCard;
